<div *ngIf="hasValue$ | async as result" class="grid">
  <app-input-wrapper [label]="label" required [value]="result.hasValue" [isDisabled]="isDisabled">
    <ng-content></ng-content>
  </app-input-wrapper>
  <app-display-errors [control]="control" *ngIf="touched" />
</div>
